let resizeHandler = null
let filterInitialized = false
let activeFetchController = null

const archiveSelector = '[data-projects-archive]'
const loadingSelectors = [
    '#hero-section',
    '#projects-filter',
    '#projects-grid',
    '#projects-load-more'
]
const replaceSelectors = loadingSelectors

const setLoading = (isLoading) => {
    loadingSelectors.forEach((selector) => {
        const el = document.querySelector(selector)

        if (!el) {
            return
        }

        el.classList.toggle('opacity-50', isLoading)
    })
}

const replaceFromDocument = (doc) => {
    replaceSelectors.forEach((selector) => {
        const currentEl = document.querySelector(selector)
        const newEl = doc.querySelector(selector)

        if (!currentEl || !newEl) {
            return
        }

        currentEl.replaceWith(newEl)
    })
}

const initLoadMore = () => {
    const buildings = document.querySelector('.js-our-buildings')
    const button = document.querySelector('.js-our-buildings-button')

    if (!buildings) {
        return
    }

    const wrapper = buildings.parentElement

    if (!wrapper) {
        return
    }

    if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler)
        resizeHandler = null
    }

    const resize = () => {
        wrapper.style.maxHeight = button ? `${buildings.scrollHeight}px` : ''
    }

    resize()

    if (!button) {
        return
    }

    resizeHandler = resize
    window.addEventListener('resize', resizeHandler)

    button.addEventListener('click', () => {
        const hiddenBuildings = Array.from(
            document.querySelectorAll('#projects-grid .hidden')
        )

        for (let i = 0; i < Math.min(6, hiddenBuildings.length); i++) {
            const el = hiddenBuildings[i]
            el.classList.remove('hidden')
            resize()
        }

        if (hiddenBuildings.length > 6) {
            return
        }

        button.style.display = 'none'
        resize()
    })
}

const loadProjectsArchive = async (url, shouldPushState = true) => {
    const archive = document.querySelector(archiveSelector)

    if (!archive) {
        return
    }

    if (activeFetchController) {
        activeFetchController.abort()
    }

    const fetchController = new AbortController()
    activeFetchController = fetchController
    setLoading(true)

    try {
        const response = await fetch(url, {
            signal: fetchController.signal,
            headers: {
                'X-Requested-With': 'fetch'
            }
        })

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`)
        }

        const html = await response.text()
        const doc = new DOMParser().parseFromString(html, 'text/html')

        replaceFromDocument(doc)
        document.title = doc.title

        if (shouldPushState) {
            window.history.pushState({}, '', url)
        }

        initLoadMore()
    } catch (error) {
        if (error.name === 'AbortError') {
            return
        }

        window.location.href = url
    } finally {
        if (activeFetchController === fetchController) {
            activeFetchController = null
            setLoading(false)
        }
    }
}

const initProjectsFilter = () => {
    if (filterInitialized || !document.querySelector(archiveSelector)) {
        return
    }

    filterInitialized = true

    document.addEventListener('click', (e) => {
        const link = e.target.closest('#projects-filter a')

        if (
            !link ||
            e.metaKey ||
            e.ctrlKey ||
            e.shiftKey ||
            e.altKey ||
            link.target
        ) {
            return
        }

        const url = new URL(link.href, window.location.href)

        if (url.origin !== window.location.origin) {
            return
        }

        e.preventDefault()

        if (url.href === window.location.href) {
            return
        }

        loadProjectsArchive(url.href)
    })

    window.addEventListener('popstate', () => {
        loadProjectsArchive(window.location.href, false)
    })
}

const initOurBuildings = () => {
    initLoadMore()
    initProjectsFilter()
}

export { initOurBuildings }
